import { render, staticRenderFns } from "./RecommendedInformation.vue?vue&type=template&id=4f7583b0&scoped=true"
import script from "./RecommendedInformation.vue?vue&type=script&lang=js"
export * from "./RecommendedInformation.vue?vue&type=script&lang=js"
import style0 from "./RecommendedInformation.vue?vue&type=style&index=0&id=4f7583b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7583b0",
  null
  
)

export default component.exports